import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';

import { AuthenticationService } from './core/services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router,
                private authService: AuthenticationService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.authService.isAuthenticated()) {
            return true;
        }

        this.router.navigate([{ outlets: { popup: 'login' }}]);
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/auth-guard.service.ts